module.exports = __webpack_public_path__ + "static/ganesh-1dbd4060e3953a4ff534c0a113f338c0.png";